/** Ticker + countdown formatting for fuse countdowns (display-only — the
 *  server's due_at is the truth; EC-40 is decided by row locks, never here). */
import { useEffect, useState } from "react";

/** Re-render every `intervalMs` (default 1 s — fuse countdowns are dramatic). */
export function useNow(intervalMs = 1000): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const t = window.setInterval(() => setNow(Date.now()), intervalMs);
    return () => window.clearInterval(t);
  }, [intervalMs]);
  return now;
}

/** "47h 12m" / "05:12" style remaining string from ms. */
export function formatRemaining(ms: number): string {
  if (ms <= 0) return "00:00";
  const totalMinutes = Math.floor(ms / 60_000);
  const days = Math.floor(totalMinutes / 1440);
  const hours = Math.floor((totalMinutes % 1440) / 60);
  const minutes = totalMinutes % 60;
  if (days > 0) return `${days}d ${hours}h`;
  if (hours > 0) return `${hours}h ${String(minutes).padStart(2, "0")}m`;
  const seconds = Math.floor((ms % 60_000) / 1000);
  return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
}

/** Remaining ms for a fuse view (frozen fuses use the stored remainder). */
export function fuseRemainingMs(
  fuse: { due_at: string | null; frozen: boolean; remaining_ms: number | null },
  now: number,
): number | null {
  if (fuse.frozen) return fuse.remaining_ms;
  if (!fuse.due_at) return null;
  return Math.max(0, new Date(fuse.due_at).getTime() - now);
}
